<div class="px-3 mt-4 mb-4">
  <sxw-slider-input
    [minValue]="minValue()"
    [maxValue]="maxValue()"
    [step]="step()"
    [range]="true"
    [value]="[value?.min ?? minValue(), value?.max ?? maxValue()]"
    sliderClass="w-full"
    (valueChange)="changeRange($event)"></sxw-slider-input>
</div>
<div class="flex gap-4 mt-2">
  <div class="w-1/2">
    <label class="block text-xs text-gray-500 mb-1">{{ minLabel() | translate }}</label>
    <sxw-number-input
      [minValue]="minValue()"
      [maxValue]="maxValue()"
      [stepValue]="step()"
      [value]="value?.min ?? minValue()"
      (valueChange)="changeMin($event)"></sxw-number-input>
  </div>
  <div class="w-1/2">
    <label class="block text-xs text-gray-500 mb-1">{{ maxLabel() | translate }}</label>
    <sxw-number-input
      [minValue]="minValue()"
      [maxValue]="maxValue()"
      [value]="value?.max ?? maxValue()"
      [stepValue]="step()"
      (valueChange)="changeMax($event)"></sxw-number-input>
  </div>
</div>
